import React, { useState, useEffect } from "react";

function LeftBarDesign({ gradientcolor, innerDesign }) {
  const [gcolor, setGcolor] = useState([]);
  useEffect(() => {
    const colorArr = gradientcolor?.split(",") || [];
    let colors = [];
    colorArr.forEach((item, index, array) => {
      if (index !== array.length - 1) {
        colors.push("#" + item);
      }
    });
    setGcolor(colors.toString());
  }, []);
  return (
    <div
      className="container-fluid"
      style={{ fontFamily: "font-family: 'Montserrat', sans-serif;" }}
    >
      <div className="row">
        <div
          className="col-md-3 d-sm-none d-none d-md-block d-lg-block"
          style={{
            background: `linear-gradient(${gcolor})`,
            minHeight: "100vh",
            overflow: "hidden",
          }}
        >
          <div className="text-center mt-4">
            <img src={""} className="w-50" />
          </div>
        </div>
        <div className="col-md-9">
          <div className="row">
            <div className="col-md-9 p-5">{innerDesign}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LeftBarDesign;
